import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "real-time-player__inner" }
const _hoisted_2 = {
  key: 0,
  class: "real-time-player__ttl"
}
const _hoisted_3 = { class: "real-time-player__btns" }
const _hoisted_4 = { class: "real-time-player__btns__item" }
const _hoisted_5 = { class: "real-time-player__btns__item" }

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { ButtonItem, PopupWindow } from "../";
import { withDefaults, ref } from "vue";

interface Props {
  modifires?: typeModifires;
  title?: string;
  text?: {
    play?: string;
    stop?: string;
  };
  isPlaying?: boolean;
  isOpen?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'real-time-player',
  props: {
    modifires: { type: [String, Array, Boolean] },
    title: {},
    text: { default: () => ({}) },
    isPlaying: { type: Boolean },
    isOpen: { type: Boolean }
  },
  emits: ["playClick", "stopClick"],
  setup(__props: any, { emit }) {

const props = __props;





/**
 * ドラッグエリアスタイル
 */
const dragStyle = ref({
  top: window.document.body.clientHeight - 126 + "px",
  left: "280px",
});

const handlePlayClick = (e: Event) => {
  emit("playClick", e);
};

const handleStopClick = (e: Event) => {
  emit("stopClick", e);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PopupWindow), {
    "data-html2canvas-ignore": "",
    windowId: "realTimePlayer",
    width: "227px",
    draggable: true,
    hideHeader: true,
    style: _normalizeStyle(dragStyle.value),
    isOpen: _ctx.isOpen
  }, {
    "main-content": _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_unref(mapModifires)('real-time-player', _ctx.modifires))
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(ButtonItem), {
                onClick: handlePlayClick,
                modifires: "play",
                disabled: props.isPlaying
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.text.play), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createTextVNode(" " + _toDisplayString(props.text.play), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(ButtonItem), {
                onClick: handleStopClick,
                modifires: "stop",
                disabled: !props.isPlaying
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.text.stop), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createTextVNode(" " + _toDisplayString(props.text.stop), 1)
            ])
          ])
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["style", "isOpen"]))
}
}

})